module.exports = __webpack_public_path__ + "static/media/speaker_PropTechAllianceAndrew.5e757be0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_PropTechAllianceAndrew.jpg
// module id = 251
// module chunks = 0